import { render, staticRenderFns } from "./ManageCategories.modal.vue?vue&type=template&id=7d177a46"
import script from "./ManageCategories.modal.vue?vue&type=script&lang=ts"
export * from "./ManageCategories.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageCategories.modal.vue?vue&type=style&index=0&id=7d177a46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports